import * as React from 'react';
import { ServiceSummary } from '../../../features/service-summary';
const Sms = ({ onServiceDelete }) => {
    return (React.createElement(ServiceSummary, { serviceType: "Sms", onDelete: onServiceDelete }, content => React.createElement(React.Fragment, null, content)));
};
export default Sms;
